// removed by extract-text-webpack-plugin
module.exports = {"questionBox":"oDk2GNcY4hfMGpXbMe-by","content":"_2H-kiDCg2dZBsPZgiozTMQ"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/PricingPlans/Question.scss
// module id = 1178
// module chunks = 0